import { TableCard } from '../../../../components'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { DownloadAsoTable } from './table/DownloadAsoTable'
import { DownloadAsoListHeader } from './component/header/DownloadAsoListHeader'

const DownloadAsoList = () => {
  return (
    <TableCard>
      <DownloadAsoListHeader />
      <DownloadAsoTable />
    </TableCard>
  )
}

export const DownloadAsoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <DownloadAsoList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
